export enum EMajorationType {
	SundayAndHolyday = "Dim",
	NightFirstHalf = "N1",
	NightSecondHalf = "N2",
	Mau = "MAU",
	Mci = "MCI",
	Mie = "MIE",
	Mip = "MIP"
}